var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2133(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206.346,
    height: 232.739,
    viewBox: "0 0 206.346 232.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    "data-name": "Group 2133",
    transform: "translate(-70.417 -431.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4296",
    "data-name": "Path 4296",
    d: "M27.467,486.029S-21.034,533-73.37,533s-105.509-44.3-105.509-44.3c7.155-42.613,30.156-67.439,92.561-70.661C-7.642,413.974,20.332,445.011,27.467,486.029Z",
    transform: "translate(249.297 130.968)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4297",
    "data-name": "Path 4297",
    d: "M-86.294,443.518a54.34,54.34,0,0,1-54.087-54.363,54.311,54.311,0,0,1,54.935-54.273c29.779.191,53.821,24.695,53.7,54.734A54.355,54.355,0,0,1-86.294,443.518Z",
    transform: "translate(257.319 96.348)",
    fill: "#e9e9e9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2133);
export default __webpack_public_path__ + "static/media/Group 2133.104a99cf65e03f64b001cebdff7cb22c.svg";
export { ForwardRef as ReactComponent };